import { useMutation, useQuery } from '@tanstack/react-query';
import { sendRequest } from 'api/sendRequest';
import { useToast } from 'components/hooks/useToast';
import { useDispatch } from 'react-redux';
import {
  setCalibrationScoreSettings,
  setGridDefinition,
  useCalibrationScoreSettings,
  useGridDefinition,
  useReviewCreationData,
} from 'reducers/reviewCreationSlice';

import { endpoints } from 'constants/endpoints';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { useReviewCreationNavigation } from '../useReviewCreationNavigation';

// const mockData = {
//   message: 'Review cycle calibration settings fetched Successfully',
//   entity: {
//     calibrationSettings: {
//       calibrationScoreSettings: {
//         id: 710,
//         organizationId: 1661,
//         description: '',
//         answerType: 'STAR_RATING',
//         questionType: 'OVERALL',
//         isArchived: false,
//         isViewOnlyModeEnabled: false,
//         enableFeedbackText: false,
//         answerOptions: [
//           {
//             id: 45155,
//             description: '',
//             score: 1.0,
//             displayOrder: 1,
//             questionId: 710
//           },
//           {
//             id: 45156,
//             description: '',
//             score: 2.0,
//             displayOrder: 2,
//             questionId: 710
//           },
//           {
//             id: 45157,
//             description: '',
//             score: 3.0,
//             displayOrder: 3,
//             questionId: 710
//           },
//           {
//             id: 45158,
//             description: '',
//             score: 4.0,
//             displayOrder: 4,
//             questionId: 710
//           },
//           {
//             id: 45159,
//             description: '',
//             score: 5.0,
//             displayOrder: 5,
//             questionId: 710
//           }
//         ],
//         selectedAnswerOptions: null,
//         feedbackText: null,
//         feedbackTextHtml: null,
//         analyticsQuestionType: null,
//         tag: null,
//         isTextRequired: true,
//         minOptions: null,
//         maxOptions: null,
//         isRequired: false,
//         formType: 'REVIEW',
//         isPredefined: true,
//         hasCustomDescription: false,
//         maxRating: 5.0
//       },
//       gridDefinition: {
//         1: [
//           {
//             columnNumber: 1,
//             color: 'grey',
//             label: 'Must Change',
//             scoreRange: {
//               PERFORMANCE: {
//                 minScore: 0.0,
//                 maxScore: 1.25
//               },
//               POTENTIAL: {
//                 minScore: 0.0,
//                 maxScore: 1.25
//               }
//             }
//           },
//           {
//             columnNumber: 2,
//             color: 'grey',
//             label: 'Must Change',
//             scoreRange: {
//               PERFORMANCE: {
//                 minScore: 1.25,
//                 maxScore: 2.5
//               },
//               POTENTIAL: {
//                 minScore: 0.0,
//                 maxScore: 1.25
//               }
//             }
//           },
//           {
//             columnNumber: 3,
//             color: 'red',
//             label: 'Over Performer',
//             scoreRange: {
//               PERFORMANCE: {
//                 minScore: 2.5,
//                 maxScore: 3.75
//               },
//               POTENTIAL: {
//                 minScore: 0.0,
//                 maxScore: 1.25
//               }
//             }
//           },
//           {
//             columnNumber: 4,
//             color: 'red',
//             label: 'Over Performer',
//             scoreRange: {
//               PERFORMANCE: {
//                 minScore: 3.75,
//                 maxScore: 5.0
//               },
//               POTENTIAL: {
//                 minScore: 0.0,
//                 maxScore: 1.25
//               }
//             }
//           }
//         ],
//         2: [
//           {
//             columnNumber: 1,
//             color: 'orange',
//             label: 'Can Recover',
//             scoreRange: {
//               PERFORMANCE: {
//                 minScore: 0.0,
//                 maxScore: 1.25
//               },
//               POTENTIAL: {
//                 minScore: 1.25,
//                 maxScore: 2.5
//               }
//             }
//           },
//           {
//             columnNumber: 2,
//             color: 'orange',
//             label: 'Can Recover',
//             scoreRange: {
//               PERFORMANCE: {
//                 minScore: 1.25,
//                 maxScore: 2.5
//               },
//               POTENTIAL: {
//                 minScore: 1.25,
//                 maxScore: 2.5
//               }
//             }
//           },
//           {
//             columnNumber: 3,
//             color: 'red',
//             label: 'Over Performer',
//             scoreRange: {
//               PERFORMANCE: {
//                 minScore: 2.5,
//                 maxScore: 3.75
//               },
//               POTENTIAL: {
//                 minScore: 1.25,
//                 maxScore: 2.5
//               }
//             }
//           },
//           {
//             columnNumber: 4,
//             color: 'red',
//             label: 'Over Performer',
//             scoreRange: {
//               PERFORMANCE: {
//                 minScore: 3.75,
//                 maxScore: 5.0
//               },
//               POTENTIAL: {
//                 minScore: 1.25,
//                 maxScore: 2.5
//               }
//             }
//           }
//         ],
//         3: [
//           {
//             columnNumber: 1,
//             color: 'blue',
//             label: 'Missionaries',
//             scoreRange: {
//               PERFORMANCE: {
//                 minScore: 0.0,
//                 maxScore: 1.25
//               },
//               POTENTIAL: {
//                 minScore: 2.5,
//                 maxScore: 3.75
//               }
//             }
//           },
//           {
//             columnNumber: 2,
//             color: 'blue',
//             label: 'Missionaries',
//             scoreRange: {
//               PERFORMANCE: {
//                 minScore: 1.25,
//                 maxScore: 2.5
//               },
//               POTENTIAL: {
//                 minScore: 2.5,
//                 maxScore: 3.75
//               }
//             }
//           },
//           {
//             columnNumber: 3,
//             color: 'green',
//             label: 'Must Retain',
//             scoreRange: {
//               PERFORMANCE: {
//                 minScore: 2.5,
//                 maxScore: 3.75
//               },
//               POTENTIAL: {
//                 minScore: 2.5,
//                 maxScore: 3.75
//               }
//             }
//           },
//           {
//             columnNumber: 4,
//             color: 'green',
//             label: 'Must Retain',
//             scoreRange: {
//               PERFORMANCE: {
//                 minScore: 3.75,
//                 maxScore: 5.0
//               },
//               POTENTIAL: {
//                 minScore: 2.5,
//                 maxScore: 3.75
//               }
//             }
//           }
//         ],
//         4: [
//           {
//             columnNumber: 1,
//             color: 'blue',
//             label: 'Missionaries',
//             scoreRange: {
//               PERFORMANCE: {
//                 minScore: 0.0,
//                 maxScore: 1.25
//               },
//               POTENTIAL: {
//                 minScore: 3.75,
//                 maxScore: 5.0
//               }
//             }
//           },
//           {
//             columnNumber: 2,
//             color: 'blue',
//             label: 'Missionaries',
//             scoreRange: {
//               PERFORMANCE: {
//                 minScore: 1.25,
//                 maxScore: 2.5
//               },
//               POTENTIAL: {
//                 minScore: 3.75,
//                 maxScore: 5.0
//               }
//             }
//           },
//           {
//             columnNumber: 3,
//             color: 'green',
//             label: 'Must Retain',
//             scoreRange: {
//               PERFORMANCE: {
//                 minScore: 2.5,
//                 maxScore: 3.75
//               },
//               POTENTIAL: {
//                 minScore: 3.75,
//                 maxScore: 5.0
//               }
//             }
//           },
//           {
//             columnNumber: 4,
//             color: 'green',
//             label: 'Bar Raisers',
//             scoreRange: {
//               PERFORMANCE: {
//                 minScore: 3.75,
//                 maxScore: 5.0
//               },
//               POTENTIAL: {
//                 minScore: 3.75,
//                 maxScore: 5.0
//               }
//             }
//           }
//         ]
//       }
//     }
//   }
// };

const getCalibrationSettings = ({ reviewCycleId }) => {
  const url = endpoints.reviews.reviewCycleCreation.calibrationSettings;
  //   return Promise.resolve(mockData);
  //   //   return Promise.resolve({});

  return sendRequest({
    url,
    credentials: 'include',
    queryParams: {
      review_cycle_id: reviewCycleId,
    },
  });
};

const putCalibrationSettings = ({ reviewCycleId, calibrationScoreSettings, gridDefinition }) => {
  const url = endpoints.reviews.reviewCycleCreation.calibrationSettings;

  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      review_cycle_id: reviewCycleId,
    },
    body: {
      calibrationSettings: {
        calibrationScoreSettings,
        gridDefinition,
      },
    },
  });
};

export const useGetCalibrationSettings = ({ reviewCycleId }) => {
  const dispatch = useDispatch();
  return useQuery(
    [REACT_QUERY_KEYS.reviewCreation.CALIBRATION, reviewCycleId],
    () =>
      getCalibrationSettings({ reviewCycleId }).then((res) => {
        // // have to do this q ki galat answer type aa rha hai
        // // DROP_DOWN  and NUMBER_RATING are the existing types unless being changed
        // if (
        //   res?.entity?.calibrationSettings?.calibrationScoreSettings?.answerType === 'STAR_RATING'
        // ) {
        //   res.entity.calibrationSettings.calibrationScoreSettings.answerType = 'NUMBER_RATING';
        // }

        // const { calibrationSettings } = mockData.entity;
        // dispatch(setCalibrationScoreSettings(calibrationSettings.calibrationScoreSettings));
        // dispatch(setGridDefinition(calibrationSettings.gridDefinition));
        // return mockData.entity;
        const { calibrationSettings } = res.entity;
        dispatch(setCalibrationScoreSettings(calibrationSettings.calibrationScoreSettings));
        dispatch(setGridDefinition(calibrationSettings.gridDefinition));
        return res.entity;
      }),
    { enabled: !!reviewCycleId }
  );
};

export const useSaveCalibrationSettings = () => {
  const toast = useToast();
  // const queryClient = useQueryClient();
  //   const dispatch = useDispatch();
  const { goToNextStep, goToStep } = useReviewCreationNavigation();

  const { reviewCycleId } = useReviewCreationData();
  const calibrationScoreSettings = useCalibrationScoreSettings();
  const gridDefinition = useGridDefinition();
  // const { rowsCount, columnsCount } = useGridDefinitionMetaData();
  // const selectedGridDefinition = gridDefinition[`${rowsCount}x${columnsCount}`];

  return useMutation({
    mutationFn: () =>
      putCalibrationSettings({
        reviewCycleId,
        calibrationScoreSettings,
        gridDefinition,
        // : selectedGridDefinition
      }),
    onSuccess: (_data, variables) => {
      if (variables?.nextStep) {
        goToStep(variables.nextStep);
        return;
      }
      //   dispatch(setReviewCycleId(data.entity));
      // todo: navigate to next step
      goToNextStep();
    },
    onError: (error) => {
      const errorMessage = error.body?.message;
      toast({ title: errorMessage, status: 'error' });
      //   if (errorMessage) {
      //     dispatch(setReviewTypeAndDetails({ name: '' }));
      //   }
    },
  });
};
